<template>
	<div v-if="!errorAccountConversion">
		<div id="convertAccountModal" v-show="!accountExists && !success && !error">
			<div class="modal-content">
				<div class="modal-header alert-success">
					<span id="convertAccountModalLabel">
						<b>{{ $translate("Eros::Template.confirmationConverterStep") }}</b>
						{{ $translate("Eros::Template.confirmationConverterOptional") }}
					</span>
				</div>
				<div class="modal-body">
					<span class="h2">{{
						$translate("Eros::Template.confirmationConverterCompleteAccount")
					}}</span>
					<div class="progress mt-3" style="height: 25px; border: 1px solid #555;" >
						<div
							role="progressbar"
							aria-valuenow="90"
							aria-valuemin="0"
							aria-valuemax="100"
							class="bg-success progress-bar"
							style="width: 98%;font-size: 1rem;font-weight: bold;"
						>
							{{ $translate("Eros::Template.confirmationConverterAlmostDone") }}
						</div>
					</div>
					<ul class="list-inline my-3">
						<li>
							<i class="fa fa-check text-success"></i>
							{{ $translate("Eros::Template.confirmationConverterReason1") }}
						</li>
						<li>
							<i class="fa fa-check text-success"></i>
							{{ $translate("Eros::Template.confirmationConverterReason2") }}
						</li>
						<li>
							<i class="fa fa-check text-success"></i>
							{{ $translate("Eros::Template.confirmationConverterReason3") }}
						</li>
					</ul>
					<form>
						<input type="hidden" name="username" :value="this.email" />
						<div class="input-unit mb-0">
							<input
								:type="showPwd ? 'text' : 'password'"
								name="password"
								id="password"
								v-model="passwordInput"
								autocomplete="new-password"
							/>
							<label for="password">
								{{ $translate("Eros::Template.confirmationConverterNewPassword") }}
							</label>
							<span id="pwd-toogle" @click="showPwd = !showPwd"
								><span class="text-black-50">{{
									$translate("Eros::Template.confirmationConverterShowPwd")
								}}</span></span
							>
						</div>
					</form>
				</div>
				<div class="modal-footer">
					<button
						class="btn btn-primary btn-block btn-lg"
						type="submit"
						@click="submit()"
						:disabled="disabled"
					>
						{{ $translate("Eros::Template.confirmationConverterCreateAccount") }}
					</button>
				</div>
			</div>
		</div>
		<div class="alert alert-success" v-show="success">
			<i class="fa fa-check-circle-o"></i>
			{{ $translate("Eros::Template.confirmationConverterAccountActivated") }}
		</div>
		<div class="alert alert-danger" v-show="error">
			<i class="fa fa-check-circle-o"></i>
			{{ $translate("Eros::Template.confirmationConverterErrorOccurred") }}
		</div>
	</div>
</template>

<script>
import ApiService from "../../../ceres/services/ApiService";

export default {
	name: "convert-account",

	props: {
		email: {
			type: String
		}
	},

	data() {
		return {
			passwordInput: "",
			success: false,
			error: false,
			accountExists: true,
			errorAccountConversion: false,
			showPwd: false
		};
	},

	mounted() {
		this.checkAlreadyHasAccount();
		this.errorAccountConversion = localStorage.getItem("errorAccountConversion") === "true";
	},

	computed: {
		disabled() {
			return !this.passwordInput || (this.passwordInput && this.passwordInput.length < 6);
		}
	},

	methods: {
		checkAlreadyHasAccount() {
			ApiService.get("/rest/account-check", { mail: this.email })
				.done(response => {
					this.accountExists = response === true;
				})
				.fail(__ => {
					this.accountExists = true;
				});
		},
		submit() {
			ApiService.post("/rest/convert-account", { password: this.passwordInput })
				.done(response => {
					this.success = true;
					this.error = false;
					this.accountExists = response === true;
				})
				.fail(__ => {
					this.success = false;
					this.error = true;

					localStorage.setItem("errorAccountConversion", "true");
				});
		}
	}
};
</script>
